import * as React from "react";
export var AuthButtonView = function (_a) {
    var buttonText = _a.buttonText, focusRef = _a.focusRef;
    return (React.createElement("button", { ref: focusRef, tabIndex: 0, className: "auth-btn" }, buttonText));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/buttons/AuthButtonView.tsx
// module id = 108
// module chunks = 1